(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("antd"), require("moment"), require("$"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "antd", "moment", "$", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["base"] = factory(require("React"), require("antd"), require("moment"), require("$"), require("ReactDOM"));
	else
		root["base"] = factory(root["React"], root["antd"], root["moment"], root["$"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__7__, __WEBPACK_EXTERNAL_MODULE__10__, __WEBPACK_EXTERNAL_MODULE__18__) {
return 